const accessCodeExists = ({ inputValue, inputName, errorText, errors }) => {
  const addError = { ...errors }
  if (!inputValue && !errors[inputName]) {
    addError[inputName] = errorText
  }
  return addError
}

export { accessCodeExists }
